export type CompanySectionOrderSource = {
  domain?: string;
  section_order?: string[];
};

const PAN_Y_MIEL_SECTION_ORDER = [
  '/pan-y-miel',
  '/pan-y-miel/ventas-direccion',
  '/pan-y-miel/ventas',
  '/pan-y-miel/produccion',
  '/pan-y-miel/costos',
  '/pan-y-miel/gastos',
  '/pan-y-miel/reportes',
  '/pan-y-miel/administracion-datos',
  '/pan-y-miel/usuarios',
  '/pan-y-miel/ayuda',
  '/pan-y-miel/admin',
];

const TERRAZA_SECTION_ORDER = [
  '/terraza',
  '/terraza/ventas-direccion',
  '/terraza/costos',
  '/terraza/gastos',
  '/terraza/reportes',
  '/terraza/usuarios',
  '/terraza/ayuda',
];

const COMPANY_SECTION_ORDER_OVERRIDES: Record<string, string[]> = {
  'pan-y-miel': PAN_Y_MIEL_SECTION_ORDER,
  terraza: TERRAZA_SECTION_ORDER,
};

function normalizeSectionKey(value: unknown): string {
  if (value == null) {
    return '';
  }

  return String(value).split('?')[0].replace(/\/+$/, '').toLowerCase();
}

function getSectionKeys(page: any): string[] {
  return [page?.url, page?.id].map((value) => normalizeSectionKey(value)).filter(Boolean);
}

export function resolveCompanySectionOrder(
  company: CompanySectionOrderSource | null | undefined,
  pages: any[] = [],
): any[] {
  const manualOrder =
    Array.isArray(company?.section_order) && company.section_order.length > 0
      ? company.section_order
      : (COMPANY_SECTION_ORDER_OVERRIDES[company?.domain ?? ''] ?? []);

  const sourcePages = Array.isArray(pages) ? pages : [];

  if (manualOrder.length === 0) {
    return [...sourcePages];
  }

  const rank = new Map<string, number>();
  manualOrder.forEach((entry, index) => {
    rank.set(normalizeSectionKey(entry), index);
  });

  const originalIndex = new Map<any, number>();
  sourcePages.forEach((page, index) => {
    originalIndex.set(page, index);
  });

  return [...sourcePages].sort((a, b) => {
    const aRank = getSectionKeys(a)
      .map((key) => rank.get(key))
      .find((value) => value !== undefined);
    const bRank = getSectionKeys(b)
      .map((key) => rank.get(key))
      .find((value) => value !== undefined);

    if (aRank !== undefined && bRank !== undefined) {
      return aRank - bRank;
    }

    if (aRank !== undefined) {
      return -1;
    }

    if (bRank !== undefined) {
      return 1;
    }

    return (originalIndex.get(a) ?? 0) - (originalIndex.get(b) ?? 0);
  });
}
